// Environment config — resolved at bundle time by Vite via import.meta.env.
// Requires envPrefix: ["VITE_", "REACT_APP_"] in the consuming Vite config.
const env = import.meta.env ?? {};
export const legacyApiBasePath = env.REACT_APP_DPLOY_LEGACY_API ?? "";
export const apiBasePath = env.REACT_APP_DPLOY_API ?? "";
//# sourceMappingURL=env.js.map